//import EventEmitter from 'common/utils/event_emitter';
//import {General} from 'common/constants';
import fetch from './fetch_etag';
import { REMARK_URL, FAKE_API_URL, REMARK_HOST } from '../constants/urls';

const builderQueryString = (qparams) => Object.keys(qparams).reduce((acc, key) => (acc + `${key}=${qparams[key] + ''}&`), '?').slice(0, -1);


//const FormData = require('form-data');

const HEADER_AUTH = 'Authorization';
const HEADER_BEARER = 'BEARER';
const HEADER_REQUESTED_WITH = 'X-Requested-With';
const HEADER_USER_AGENT = 'User-Agent';
const HEADER_X_VERSION_ID = 'X-Version-Id';
const HEADER_X_CLUSTER_ID = 'X-Cluster-Id';
const HEADER_ACCEPT = 'application/json, text/plain, */*';
const IS_DEBUG = process.env.NODE_ENV === 'development';

export default class Client4 {
  constructor() {
    this.logToConsole = false;
    this.serverVersion = '';
    this.clusterId = '';
    this.token = '';

    this.configUrl = IS_DEBUG ? REMARK_URL : ''
    this.url = IS_DEBUG ? FAKE_API_URL : ''
    this.endPoint = IS_DEBUG ? '' : '/json.php'
    this.imageBaseUrl = IS_DEBUG ? REMARK_HOST : '/images'
    this.urlVersion = '/api';
    this.userAgent = null;
    this.enableLogging = false;
    this.defaultHeaders = {};
    this.userId = '';
    this.diagnosticId = '';
    this.includeCookies = true;

    this.translations = {
      connectionError: 'There appears to be a problem with your internet connection.',
      unknownError: 'We received an unexpected status code from the server.',
    };
  }

  getUrl() {
    this.url;
  }

  setUrl(url) {
    //this.url = "https://http://localhost:8065" //url;
  }

  setUserAgent(userAgent) {
    this.userAgent = userAgent;
  }

  getToken() {
    return this.token;
  }

  setToken(token) {
    this.token = token;
  }

  setAcceptLanguage(locale) {
    this.defaultHeaders['Accept-Language'] = locale;
  }

  setEnableLogging(enable) {
    this.enableLogging = enable;
  }

  setIncludeCookies(include) {
    this.includeCookies = include;
  }

  setUserId(userId) {
    this.userId = userId;
  }

  setDiagnosticId(diagnosticId) {
    this.diagnosticId = diagnosticId;
  }

  getServerVersion() {
    return this.serverVersion;
  }

  getUrlVersion() {
    return this.urlVersion;
  }

  getBaseRoute() {
    return `${this.url}${this.endPoint}`;
  }

  getRemarkRoute() {
    return IS_DEBUG ? REMARK_HOST : REMARK_URL;
  }

  getStaticRoute() {
    return `${this.url}`;
  }

  getBaseCatalogImageUrl = () => (
    IS_DEBUG ? 'https://remark1991.ru/images' : `${REMARK_URL}/images`
  )

  getCatalogPresetsImageUrl = (article, preset, type) => {
    const sizePrefix = {
      big: 'b',
      small: 's',
      xsmall: 'xs',
    }
    return IS_DEBUG ? 
      `http://localhost:5000/images/renders/preset/${preset}/${article}_${sizePrefix[type]}.jpg` : 
              `${REMARK_URL}/images/renders/preset/${preset}/${article}_${sizePrefix[type]}.jpg`;
  }

  getCatalogPreviewImageUrl = (article, preset, type, number) => {
    const sizePrefix = {
      big: 'b',
      small: 's',
      xsmall: 'xs',
    }
    return IS_DEBUG ? 
      `http://localhost:5000/images/renders/preset/${preset}/${article}_photo${number}_${sizePrefix[type]}.jpg` : 
              `${REMARK_URL}/images/renders/preset/${preset}/${article}_photo${number}_${sizePrefix[type]}.jpg`;
  }

  getImageDetailPreview = (article) => (
    IS_DEBUG ? `images/builder/${article}.png` : `images/details/${article}.png`
  )

  getCatalogImageDetailPreview = (article) => (
    IS_DEBUG ? `http://localhost:5000/images/builder/${article}.png` : `${REMARK_URL}/images/details/${article}.png`
  )

  getRemarkConfigHost = () => {
    IS_DEBUG ? `http://localhost:5000/scripts` : `${REMARK_URL}`
  };

  getRemarkImageUrl = (article) => (
    `${this.getRemarkRoute()}/images/preview_parts/shirt/fabric/${article}/photolarge.jpg`
  )

  getRemarkImageUrlForCarousel = (article, index) => (
    `${this.getRemarkRoute()}/images/preview_parts/shirt/fabric/${article}/photobig${index}.jpg`
  )


  ///images/buttons/артикул/photo.png
  getRemarkImageUrlButton = (article) => {
    return `${this.getRemarkRoute()}/images/buttons/${article}/photo.png`
  }

  getRemarkImageUrlButtonThread = (article) => (
    `${this.getRemarkRoute()}/images/preview_parts/shirt/threads/${article}/buttonsThread_sandwich_bottom.png`
  )


  getOptions(options) {
    const newOptions = Object.assign({}, options);

    const headers = {
      [HEADER_REQUESTED_WITH]: 'XMLHttpRequest',
      ...this.defaultHeaders,
    };

    if (this.token) {
      headers[HEADER_AUTH] = `${HEADER_BEARER} ${this.token}`;
    }

    if (this.includeCookies) {
      newOptions.credentials = 'include';
    }

    if (this.userAgent) {
      headers[HEADER_USER_AGENT] = this.userAgent;
    }

    if (newOptions.headers) {
      Object.assign(headers, newOptions.headers);
    }

    return {
      ...newOptions,
      headers,
    };
  }


  getConfigFile = async (filename) => {
    return this.doFetch(
      `${this.getStaticRoute()}/${filename}`,
      { method: 'get' }
    );
  };

  /**
   * @param  {} params
   * Стандартный размер рубашек
   */
  getSize = async (params) => {
    return this.doFetch(
      `${this.getOrderRoute(orderId)}`,
      { method: 'get' }
    );
  };

  /**
   * @param  {} params
   * Сохранить профиль рубашек
   */
  createShirtProfileMaleBase = async (data) => {

    const fdata = new FormData();
    for (let key in data) {
      fdata.append(key, data[key])
    }

    return this.doFetch(
      `${this.getBaseRoute()}/createShirtProfileMaleBaseV2`,
      {
        method: 'post',
        body: fdata,
      }
    );
  };

  /**
   * @param  {} params
   * Зарегистрировать рубашку в системе и получиь ID рубашки
   */
  getDesignIdShirt = async (params = {}) => {
    return this.doFetch(
      `${this.getBaseRoute()}/getDesignIdShirt${builderQueryString(params)}`,
      { method: 'get' }
    );
  };

  /**
   * @param  {} params
   * Проверка статуса авторизации пользователя
   */
  getShirtDetails = async (params = {}) => {
    return this.doFetch(
      `${this.getBaseRoute()}/getDetails`,
      { method: 'get' }
    );
  };


  /**
   * @param  {} params
   * Ссылка на превью рубашки
   */
  getFabricImageUrl = async (article) => {
    return this.doFetch(
      `https://remark1991.com/images/preview_parts/shirt/fabric/${article}/photobig.jpg`,
      { method: 'get' }
    );
  };

  /**
   * @param  {} params
   * Логин
   */
  login = async (data) => {
    return this.doFetch(
      `${this.getBaseRoute()}/login`,
      {
        method: 'post',
        body: JSON.stringify(data),
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
      }
    );
  };



  /**
   * @param  {} params
   * Стандартный размер рубашек
   */
  getSizesProfilesList = async (data) => {
    return this.doFetch(
      `${this.getBaseRoute()}/shirtProfileListV2`,
      {
        method: 'get',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
      }
    );
  };

  /**
   * @param  {} params
   * Стандартный размер рубашек
   */
  getSizesProfilesList = async (data) => {
    return this.doFetch(
      `${this.getBaseRoute()}/shirtProfileListV2`,
      {
        method: 'get',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
        },
      }
    );
  };


  addShirt = async (params) => {
    const fdata = new FormData();
    for (let key in params) {
      fdata.append(key, params[key])
    }

    return this.doFetch(
      `${this.getBaseRoute()}/addShirt`,
      {
        method: 'post',
        body: fdata,
      }
    );
  };

  addShirtSizeRef = async (params) => {
    const fdata = new FormData();
    for (let key in params) {
      fdata.append(key, params[key])
    }

    return this.doFetch(
      `${this.getBaseRoute()}/addShirtSizeRef`,
      {
        method: 'post',
        body: fdata
      }
    );
  };

  saveShirtInProfile = async (params) => {

    return this.doFetch(
      `${this.getBaseRoute()}/saveShirtInProfile${builderQueryString(params)}`,
      {
        method: 'get',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
      }
    );
  };

  /**
   * @param  {} params
   * Получить список id дизайна рубашки
   */
  getSizesMale = async (params) => {
    return this.doFetch(
      `${this.getBaseRoute()}/getSizesMale${builderQueryString(params)}`,
      {
        method: 'get',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
      }
    );
  };

  /**
     
   */
  getAttrJS = async () => {
    let url = `${this.configUrl}/js/rnz_attr_library_shirt.js`
    if (IS_DEBUG) {
      url = 'http://localhost:3000/getAttr';
    }
    let response = await fetch(url)
    return await response.text();
  };

  /**
     
   */
  getInStockPHP = async () => {
    let url = `${this.configUrl}/in_stock.php`;
    if (IS_DEBUG) {
      url = 'http://localhost:3000/getStock';
    }
    let response = await fetch(url)
    return await response.text();
  };

  /**
     
   */
  getFabricJS = async () => {
    let url = `${this.configUrl}/js/rnz_fabric_lib.js`;
    if (IS_DEBUG) {
      url = 'http://localhost:3000/getFabric';
    }
    let response = await fetch(url)
    return await response.text();
  };

  getDesignId = async (id) => {
    let url = `${this.configUrl}/json.php/getDesignIdByShirtId?objectType=shirt&shirtId=${id}`;
    if (IS_DEBUG) {
      url = `http://localhost:3000/getDesignIdByShirtId?objectType=shirt&shirtId=${id}`;
    }
    let response = await fetch(url)
    return await response.json();
  }

  getDetailsById = async (id) => {
    let url = `${this.configUrl}/json.php/getDesignShirt?designId=${id}`;
    if (IS_DEBUG) {
      url = `http://localhost:3000/getDesignShirt?designId=${id}`;
    }
    let response = await fetch(url)
    return await response.json();
  }

  getPresetsJSON = async () => {
    let url = `${this.configUrl}/js/rnz_presets.json`;
    if (IS_DEBUG) {
      url = 'http://localhost:3000/getPresets';
    }
    let response = await fetch(url)
    return await response.json();
  };


  // Client Helpers

  doFetch = async (url, options) => {
    const { data } = await this.doFetchWithResponse(url, options);
    return data;
  };

  doFetchWithResponse = async (url, options) => {
    const response = await fetch(url, this.getOptions(options));
    const headers = parseAndMergeNestedHeaders(response.headers);

    let data;
    try {
      data = await response.json();
    } catch (err) {
      throw {
        intl: {
          id: 'mobile.request.invalid_response',
          defaultMessage: 'Received invalid response from the server.',
        },
      };
    }

    // Need to only accept version in the header from requests that are not cached
    // to avoid getting an old version from a cached response
    if (headers.has(HEADER_X_VERSION_ID) && !headers.get('Cache-Control')) {
      const serverVersion = headers.get(HEADER_X_VERSION_ID);
      if (serverVersion && this.serverVersion !== serverVersion) {
        this.serverVersion = serverVersion;
        //EventEmitter.emit(General.SERVER_VERSION_CHANGED, serverVersion);
      }
    }

    if (headers.has(HEADER_X_CLUSTER_ID)) {
      const clusterId = headers.get(HEADER_X_CLUSTER_ID);
      if (clusterId && this.clusterId !== clusterId) {
        this.clusterId = clusterId;
      }
    }


    if (true) {
      return {
        response,
        headers,
        data,
      };
    }


    const msg = data.message || '';

    if (this.logToConsole) {
      console.error(msg); // eslint-disable-line no-console
    }

    throw {
      message: msg,
      server_error_id: data.id,
      status_code: data.status_code,
      url,
    };
  };

  doFetchBlob = async (url, options) => {
    const { data } = await this.doFetchWithResponseBlob(url, options);
    return data;
  };

  doFetchWithResponseBlob = async (url, options) => {

    const response = await fetch(url, this.getOptions(options));
    const headers = parseAndMergeNestedHeaders(response.headers);

    let data;
    try {
      data = await response.blob();
    } catch (err) {
      throw {
        intl: {
          id: 'mobile.request.invalid_response',
          defaultMessage: 'Received invalid response from the server.',
        },
      };
    }

    // Need to only accept version in the header from requests that are not cached
    // to avoid getting an old version from a cached response
    if (headers.has(HEADER_X_VERSION_ID) && !headers.get('Cache-Control')) {
      const serverVersion = headers.get(HEADER_X_VERSION_ID);
      if (serverVersion && this.serverVersion !== serverVersion) {
        this.serverVersion = serverVersion;
        //EventEmitter.emit(General.SERVER_VERSION_CHANGED, serverVersion);
      }
    }

    if (headers.has(HEADER_X_CLUSTER_ID)) {
      const clusterId = headers.get(HEADER_X_CLUSTER_ID);
      if (clusterId && this.clusterId !== clusterId) {
        this.clusterId = clusterId;
      }
    }

    if (response.ok) {
      return {
        response,
        headers,
        data,
      };
    }


    const msg = data.message || '';

    if (this.logToConsole) {
      console.error(msg); // eslint-disable-line no-console
    }

    throw {
      message: msg,
      server_error_id: data.id,
      status_code: data.status_code,
      url,
    };
  };

  update_cart_info = async () => {
    let url = `${this.configUrl}/parts.php/b_cart_info`;

    await fetch(url).then(function (response) {
      return response.text()
    }).then(function (html) {
      document.querySelector("#cart-info").innerHTML = html;
      document.querySelector("#cart-info-mobile").innerHTML = html;
    })
  };
}


function parseAndMergeNestedHeaders(originalHeaders) {
  const headers = new Map();
  let nestedHeaders = new Map();
  originalHeaders.forEach((val, key) => {
    const capitalizedKey = key.replace(/\b[a-z]/g, (l) => l.toUpperCase());
    let realVal = val;
    if (val && val.match(/\n\S+:\s\S+/)) {
      const nestedHeaderStrings = val.split('\n');
      realVal = nestedHeaderStrings.shift();
      const moreNestedHeaders = new Map(
        nestedHeaderStrings.map((h) => h.split(/:\s/))
      );
      nestedHeaders = new Map([...nestedHeaders, ...moreNestedHeaders]);
    }
    headers.set(capitalizedKey, realVal);
  });
  return new Map([...headers, ...nestedHeaders]);
}
